import { ProductPlatformFeatures } from 'shared/api/resources'
import { doAdminQueries } from 'infrastructure/api'
import { atomFamily } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { Single } from 'infrastructure/api'

async function fetchProductPlatformFeatures(productId: number) {
  return doAdminQueries<Single.ProductPlatformFeatureResponse>([
    {
      resourceData: ProductPlatformFeatures,
      params: {
        product_id: productId,
      },
    },
  ])
}

export const productPlatformFeaturesAtomFamily = atomFamily(
  (productId: number) =>
    atom(async () => {
      const features = await fetchProductPlatformFeatures(productId)
      return features.data.productPlatformFeatures
    }),
)
